import "./QuickDetectTraceNarcotics.module.css";
import Header from "@/reusable_sections/Header";
import Quickdetect from "./sections/Quickdetect";
import ApplicationAreas from "./sections/ApplicationAreas";
import SafetyEcosystem from "./sections/SafetyEcosystem";
import ServicesGrid from "./sections/ServicesGrid";
import Inquiry from "./sections/Inquiry";
import Footer from "@/reusable_sections/Footer";
export default function QuickDetectTraceNarcoticsPage() {
  return <div>
      <Header />
      <Quickdetect />
      <ApplicationAreas />
      <SafetyEcosystem />
      <ServicesGrid />
      <Inquiry />
      <Footer />
    </div>;
}